<template>
  <v-app-bar app color="primaryDark" dark clipped-left class="axp-appbar">
    <!-- Logo wrapper - fixed width to align market dropdown with main content -->
    <div class="logo-wrapper">
      <!-- Mobile nav trigger - visible only on small screens -->
      <v-app-bar-nav-icon
        v-if="loggedIn"
        class="nav-trigger"
        @click.stop="$emit('openDrawer')"
        aria-label="Open navigation"
      ></v-app-bar-nav-icon>

      <div class="d-flex align-center logo-container">
        <img
          src="@/assets/AssetXP_White.svg"
          alt="AssetXP Logo"
          class="appbar-logo"
        />
      </div>
    </div>

    <WorkspaceSwitcher
      v-if="loggedIn && !hideWorkspaceAndMarketSelectors"
      class="appbar-workspace-switcher"
    />
    <MarketSelection
      v-if="loggedIn && !hideWorkspaceAndMarketSelectors"
      class="appbar-market-selection"
    />

    <v-spacer />

    <div
      v-if="loggedIn && items.length > 1"
      class="appbar-breadcrumb-wrapper"
    >
      <v-breadcrumbs :items="items" class="appbar-breadcrumbs pa-0 ma-0">
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </div>

    <v-menu
      v-model="showMenu"
      :close-on-content-click="false"
      offset-y
      v-if="loggedIn"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="user-menu-btn"
          color=""
          tile
          small
        >
          <v-icon left small>
            mdi-account
          </v-icon>
          <span class="user-menu-btn__name">{{ userName }}</span>
        </v-btn>
      </template>

      <v-card width="300px" tile color="white" class="pa-2">
        <span class="subtitle-2"
          >Logged in as <b>{{ userName }}</b>
        </span>
        <v-divider class="mt-2 mb-2" />
        <v-btn tile width="100%" color="primaryDark" dark @click="onLogout">
          Logout
        </v-btn>
      </v-card>
    </v-menu>
    <v-dialog v-model="inactivityDialog" persistent max-width="400">
      <v-card class="pl-4 pr-4">
        <v-row>
          <v-col>
            <v-card-title>
              Inactivity timeout
            </v-card-title>
            <v-card-text class="pl-0">
              You have been inactive for 23 hours, you will be automatically
              logged out if no activity is detected in the next 5 minutes.
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
import CONFIG from "../../appconfig.json";
import MarketSelection from "../../components/navigation/MarketSelection.vue";
import WorkspaceSwitcher from "../../components/navigation/WorkspaceSwitcher.vue";
import { LogOut } from "../../js/authentication/authentication";

export default {
  components: { MarketSelection, WorkspaceSwitcher },
  props: {},
  computed: {
    userName() {
      return this.$store.state.authentication.userName;
    },
    platformLogo() {
      return CONFIG.clientBranding.logos.smallSquare;
    },
    canShowAppMenu() {
      return CONFIG.platformOptions.showAppMenu;
    },
    hideWorkspaceAndMarketSelectors() {
      // Temporary kill switch (see App.vue's applyWorkspaceCrossAppSync for the matching half,
      // and docs/workspace-market-switching-kill-switch.md): workspace/market switching is
      // hard-disabled in production while the cross-app sync account-scoping bug is fixed
      // properly. No production account currently has more than one workspace/market, so this
      // is a no-op for everyone today — it just guarantees the selectors stay hidden regardless
      // of that count. To re-enable, restore the previous workspaceCount/marketCount logic (see
      // git history for this file) and remove this comment.
      return true;
    },
    ...mapState("assetxpstate", ["asset", "section", "markets"]),
    ...mapState("appbarstate", ["title"]),
    ...mapState("authentication", ["loggedIn"]),
    ...mapState("workspace", ["availableWorkspaces"]),
  },
  data: () => ({
    items: [],
    showMenu: false,
    inactivityDialog: false,
  }),
  mounted: function() {
    this.startInactivityTimer();
    this.updateBreadcrumb();
  },
  methods: {
    startInactivityTimer() {
      window.onload = this.resetTimer;
      // DOM Events
      document.onmousemove = this.resetTimer;
      document.onkeydown = this.resetTimer;
    },
    resetTimer() {
      this.inactivityDialog = false;
      if (this.$options.inactivityTimer != null) {
        clearTimeout(this.$options.inactivityTimer);
        clearTimeout(this.$options.inactivityWarning);
      }

      this.$options.inactivityWarning = setTimeout(
        this.showWarning,
        1000 * (60 * 1380)
      );
      this.$options.inactivityTimer = setTimeout(
        this.onLogout,
        1000 * (60 * 1385)
      );
    },
    showWarning() {
      this.inactivityDialog = true;
    },
    onLogout() {
      LogOut();
    },
    onlinkclick(url) {
      window.open(url);
    },
    updateBreadcrumb() {
      this.items = [];

      this.items.push({
        text: "Sections",
        disabled: false,
        to: "/",
      });

      if (this.section !== null) {
        this.items.push({
          text: this.section.name,
          disabled: this.asset === null,
          to: "/section/" + encodeURI(this.section.name) + "/search/",
        });
      }

      if (this.asset !== null) {
        this.items.push({
          text: this.asset.name,
          disabled: this.asset !== null,
          to: "/asset/" + this.asset.assetDetailid,
        });
      }
    },
  },
  watch: {
    section() {
      this.updateBreadcrumb();
    },
    asset() {
      this.updateBreadcrumb();
    },
  },
};
</script>

<style>
/* Styles moved to src/styles/AppBar.scss for global application */
</style>
